import React from 'react';
import Header from '../Landingpage/Header';
import Hero from './Hero';
import TopicSelector from './TopicSelector';
import Footer from '../../Company/About/Footer';
import Navbar from '../../Company/About/Navbar';

function InterviewPage() {
  return (
    <div className="min-h-screen w-full bg-background flex flex-col">
      <div className="flex-1">
        <Navbar />
        <Hero />
      </div>
      <TopicSelector />
      <Footer />
    </div>
  );
}

export default InterviewPage;